import { NgModule } from '@angular/core';
import { WidgetsModule } from '../widgets/widgets.module';
import { AllfilesComponent } from './allfiles/allfiles.component';
import { TranscriptComponent } from './transcript/transcript.component';
import { ViewOutputComponent } from './view-output/view-output.component';
import { ReviewSpeakerComponent } from './review-speaker/review-speaker.component';
import { TranslateComponent } from './translate/translate.component';
import { VoiceAnnotationsComponent } from './voice-annotations/voice-annotations.component';
import { APP_PRIMENG_MODULE } from '../utils/ngprime-packages';

@NgModule({
  declarations: [
    AllfilesComponent,
    TranscriptComponent,
    ViewOutputComponent,
    ReviewSpeakerComponent,
    TranslateComponent,
    VoiceAnnotationsComponent
  ],
  imports: [
    WidgetsModule,
    APP_PRIMENG_MODULE
  ],
  exports: [
    AllfilesComponent,
    TranscriptComponent,
    ViewOutputComponent,
    ReviewSpeakerComponent,
    VoiceAnnotationsComponent,
    WidgetsModule
  ]
})
export class PagesModule { }